module.exports = __webpack_public_path__ + "Illustration-2.svg?d2f6649f6c086388e965ae248b2aa7df";